// ANGULAR IMPORTS
import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { HttpClient, HttpHandler } from '@angular/common/http';

// SERVICES
import { AuthGuardService } from './services/auth-guard.service';
import { BootstrapModalModule } from './services/modal-dialogs';
import { DialogService } from './services/modal-dialogs';
import { GlobalService } from './services/global.service';
import { MemberEventsService } from './services/member.events.service';
import { PinService } from './services/pin.service';
import { ssApiService } from './services/ss-api.service';
import { UserRolesService } from './services/user.roles.service';

// NGX-BOOTSTRAP
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDropdownModule, DatepickerModule } from 'ngx-bootstrap';

// SWEETALERT2
import { SweetAlertService } from 'ng2-cli-sweetalert2';

// PRIMARY COMPONENTS AND MODULES
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { SharedAppModule } from './app.module.shared';
import { SharedAppDialogModule } from './app.module.shared.dialogs';
import { MainComponent } from './views/main/main.component';
import { GlobalsComponent } from './debug/globals/globals.component';

// APP MODULE IMPORTS
import { AdminModule } from './_admin/admin.module';
import { AuthenticationModule } from './_authentication/authentication.module';
import { EmailTemplatesModule } from './_email.templates/email.templates.module';
import { MemberAccountModule } from './_members.account/members.account.module';
import { MonitoringModule } from './_monitoring/monitoring.module';
import { TicketsModule } from './_tickets/tickets.module';
import { TrainingModule } from './_training/training.module';
import { SalesModule } from './_sales/sales.module';
import { ProfileModule } from './_profile/profile.module';
import { SoftwareStatsModule } from './_stats/software.stats.module';
import { DashboardModule } from './_dashboard/dashboard.module';
import { AuthService } from './services/auth.service';
import { TagService } from './services/tag.service';
import { TicketService } from './services/ticket.service';
import { AdminHistoryService } from './services/admin.history.service';
import { AdminPresenceService } from './services/admin.presence.service';
import { WindowService } from './services/window-dialogs/window.service';
import { SearchService } from './services/search.service';
import { BlankView } from './views/blank/blank.view';
import { LiveHubService } from './services/livehub.service';
import { UpdaterModule } from './_updater/updater.module';
import { ErrorsComponent } from './debug/errors/errors.component';

import { LogsModule } from './_logs/logs.module';
import { PoolStudioModule } from './_poolstudio/poolstudio.module';

@NgModule({
    declarations: [
        GlobalsComponent,
        ErrorsComponent,
        AppComponent
    ],
    imports: [
        // ANGULAR MODULES
        BrowserModule,
        FormsModule,
        HttpModule,
        RouterModule,
        SharedAppModule,
        SharedAppDialogModule,

        // OTHER MODULES
        BsDropdownModule.forRoot(),
        TimepickerModule.forRoot(),
        DatepickerModule.forRoot(),
        BootstrapModalModule,

		// APP MODULES
		AdminModule,
        AuthenticationModule,
        EmailTemplatesModule,
        SalesModule,
        UpdaterModule,
        TicketsModule,
        TrainingModule,
        SoftwareStatsModule,
        DashboardModule,
        MemberAccountModule,
        ProfileModule,
        MonitoringModule,
        LogsModule,
        PoolStudioModule,

        // ROUTES
        AppRoutingModule, // leave at last for ** redirect
    ],
    providers: [
        { provide: 'ORIGIN_URL', useValue: location.origin },
        // { provide: ErrorHandler, useClass: AppErrorHandler },
        AuthGuardService,
        AuthService,
        SweetAlertService,
        ssApiService,
        DialogService,
        GlobalService,
        SweetAlertService,
        PinService,
        MemberEventsService,
        TagService,
        TicketService,
        AdminHistoryService,
        UserRolesService,
        AdminPresenceService,
        WindowService,
        SearchService,
        HttpClient,
        HttpHandler,
        LiveHubService
    ],
    bootstrap: [MainComponent] // was MainComponent
})
export class AppModule {
    static injector: Injector;
    constructor(injector: Injector) {
        AppModule.injector = injector;
    }
}
